import { TaskGroup } from 'models/task-groups.model';

const FIXED_GROUP_NAME = 'other tasks';
const MAX_VISIBLE_TEXT_LENGTH = 40;

export const scrollToItem = (itemId: string) => {
  const element = document.getElementById(itemId);

  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

export const isFixedGroup = (name: string) =>
  name.toLocaleLowerCase() !== FIXED_GROUP_NAME;

export const getFixedGroupId = (groups: TaskGroup[]): string | undefined =>
  groups.find((group) => group.name === FIXED_GROUP_NAME)?.id;

export const getDataTestIdValue = (message: string) => {
  const info = message.split(' ').slice(-2).join('-');

  return `${info}-toast-message`;
};

export const getFormatedText = (text: string, to = MAX_VISIBLE_TEXT_LENGTH) =>
  text.length > to ? `${text.substring(0, to)}...` : text;

export const validateHTML = (text: string): string =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
    .replace(/\?/g, '&quest;')
    .replace(/\(/g, '&lpar;')
    .replace(/\)/g, '&rpar;')
    .replace(/\$/g, '&dollar;')
    .replace(/\^/g, '&Hat;')
    .replace(/\*/g, '&ast;');
